import styled from 'styled-components';

import { ChatConversation } from 'services/api/chat';
import { colors } from 'styles/theme/colors';
import { FONT_WEIGHT } from 'styles/theme/textStyles';
import { BodySmall, H3 } from 'styles/typography';

import ChannelEmptyState from './ChannelEmptyState';

type Props = {
  conversation: ChatConversation;
  // Multi-facility layout shows a "Viewing Chat For {facility}" header above the pane;
  // the single-facility layout (no rail) omits it, per the mockups.
  showFacilityHeader: boolean;
};

// One channel's pane. v1 is read-only: a header (multi-facility only) and the empty state.
// Messages + composer arrive in the messages story (OLIO-2833).
export default function ChannelView({ conversation, showFacilityHeader }: Props) {
  return (
    <View data-testid='chat-channel-view'>
      {showFacilityHeader && (
        <Header>
          <ViewingLabel>Viewing Chat For</ViewingLabel>
          <FacilityName>{conversation.audience.name}</FacilityName>
        </Header>
      )}
      <ChannelEmptyState facility={conversation.audience.name} />
    </View>
  );
}

const View = styled.div`
  flex: 1;
  min-width: 0;
  align-self: stretch;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 16px;
`;

const ViewingLabel = styled(BodySmall)`
  color: ${colors.black50};
`;

const FacilityName = styled(H3)`
  color: ${colors.black100};
  /* One step below H3's medium (500) per design review of the Figma comp. */
  font-weight: ${FONT_WEIGHT};
`;
